import React from "react";
import AuthSlider from "../components/AuthComponents/AuthSlider";

const LoginPage = () => {
  return <AuthSlider />;
};

export default LoginPage;
